// @ts-nocheck
export default class RecordLinkQuery {
  constructor(recordLinkElement, record, valuesForPredicate, role) {
    this.recordLinkElement = recordLinkElement;
    this.record = record;
    this.valuesForPredicate = valuesForPredicate;
    this.role = role;
  }

  get where() {
    if (!this.recordLinkElement.recordConditions.length) {
      return null;
    }

    const where = {};

    if (this.recordLinkElement.recordConditionsType === 'any') {
      where.operator = 'or';
    } else {
      where.operator = 'and';
    }

    const conditions = [];

    for (const condition of this.recordLinkElement.recordConditions) {
      let conditionValue = null;

      if (condition.valueFieldKey) {
        const systemValue = this.systemValueForKey(condition.valueFieldKey);

        // first check for special system variables (@role and @status)
        if (systemValue != null) {
          conditionValue = systemValue;
        } else {
          const formValue = this.valuesForPredicate.get(condition.valueFieldKey);

          if (formValue && !formValue.isEmpty) {
            conditionValue = formValue.textValue ?? formValue.columnValue;
          }
        }
      } else {
        conditionValue = condition.value;
      }

      const conditionAttributes = {};

      if (condition.linkedFormFieldKey) {
        conditionAttributes.field_key = condition.linkedFormFieldKey;
      }

      conditionAttributes.operator = condition.operator;

      if (conditionValue) {
        conditionAttributes.value = conditionValue;
      }

      conditions.push(conditionAttributes);
    }

    where.predicates = conditions;

    return where;
  }

  systemValueForKey(key) {
    if (key === '@role') {
      return this.role.name;
    } if (key === '@status') {
      return this.record.status;
    }

    return null;
  }
}
